import { Form } from 'react-bootstrap'

export default function Email(props) {

    const { label_name, placeholder, disabled, name, value, onChange, onBlur, error, mandatory, reference, tabIndex } = props

    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                {label_name === '' ? '' : <Form.Label className='form_label'>{label_name}{mandatory ? <span style={{ color: 'red' }}>*</span> : ''}</Form.Label>}
                <Form.Control
                    ref={reference}
                    type="email"
                    size="sm"
                    placeholder={placeholder}
                    disabled={disabled}
                    className='form_input'
                    name={name}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    tabIndex={tabIndex}
                />
                {error}
            </Form.Group>
        </>
    )
}
